export default __webpack_public_path__ + "static/media/Archpriest's Cord of the Underworld.5b0d2b86.jpg";